import { render } from "./SvgPlayerButtonPlay.vue?vue&type=template&id=000d5244&scoped=true"
import script from "./SvgPlayerButtonPlay.vue?vue&type=script&lang=js"
export * from "./SvgPlayerButtonPlay.vue?vue&type=script&lang=js"

import "./SvgPlayerButtonPlay.vue?vue&type=style&index=0&id=000d5244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000d5244"]])

export default __exports__